<template>
    <div>
        <header class="bg-white shadow">
            <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:divide-y lg:divide-gray-200 lg:px-8">
                <div class="relative h-16 flex justify-between z-20">
                    <div class="relative z-10 px-2 flex lg:px-0">
                        <div class="flex-shrink-0 flex items-center">
                            <inertia-link :href="$route('home')">
                                <img alt="Logo" class="block h-8 w-auto" src="/images/logo.png" />
                            </inertia-link>
                        </div>
                    </div>
                    <div class="relative z-10 ml-4 flex items-center">
                        <!-- Profile dropdown -->
                        <div class="flex-shrink-0 relative ml-4">
                            <div>
                                <button
                                    id="user-menu"
                                    aria-haspopup="true"
                                    class="rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                                    @click="toggleMenu"
                                >
                                    <span class="sr-only">Open user menu</span>
                                    <svg
                                        class="h-6 w-6"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                        stroke-width="1.5"
                                    ><path
                                        d="M2.25 18.003L21.75 18.003"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /><path
                                        d="M2.25 12.003L21.75 12.003"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /><path
                                        d="M2.25 6.003L21.75 6.003"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    /></svg>
                                </button>
                            </div>
                            <transition
                                enter-active-class="transition ease-out duration-100"
                                enter-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95"
                            >
                                <div class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg" v-show="menuIsOpen">
                                    <div
                                        aria-labelledby="user-menu"
                                        aria-orientation="vertical"
                                        class="bg-white rounded-md shadow-xs py-1"
                                        role="menu"
                                    >
                                        <inertia-link
                                            class="block py-2 px-4 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                            :href="$route('gestion.profile')"
                                            role="menuitem"
                                            @click="toggleMenu"
                                        >
                                            {{ $t('menu.gestion.profile') }}
                                        </inertia-link>

                                        <a
                                            download
                                            class="block py-2 px-4 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                            :href="$route('download', $page.props.account.sid)"
                                            role="menuitem"
                                        >
                                            {{ $t('menu.gestion.download') }}
                                        </a>

                                        <inertia-link
                                            class="block py-2 px-4 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                            :href="$route('gestion.logout')"
                                            role="menuitem"
                                            @click="toggleMenu"
                                        >
                                            {{ $t('menu.gestion.logout') }}
                                        </inertia-link>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="relative py-10">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 class="text-3xl font-bold text-gray-800" v-if="title">
                    {{ title }}
                </h1>
                <slot name="title" v-else>
                    <h1 class="text-3xl font-bold text-gray-800" v-if="optionAccounts.length === 1">
                        {{ $page.props.account.title }}
                    </h1>
                    <select-ui
                        class="max-w-xs"
                        :options="optionAccounts"
                        :value="$page.props.account.sid"
                        :allow-empty="false"
                        @input="changeAccount($event)"
                        v-else
                    />
                </slot>
            </div>
        </div>

        <main class="relative">
            <div class="max-w-screen-xl mx-auto pb-6 px-4 sm:px-6 lg:pb-16 lg:px-8">
                <div class="overflow-hidden">
                    <div class="lg:grid lg:grid-cols-12">
                        <aside class="pb-6 lg:col-span-3">
                            <gestion-sidebar />
                        </aside>

                        <slot />

                    </div>
                </div>
            </div>
        </main>

        <notification />
        <portal-target name="modal" />
    </div>
</template>

<script>
    import SelectUi from '@/components/ui/Select.vue';
    import GestionSidebar from '@/components/GestionSidebar.vue';

    export default {
        components: {
            GestionSidebar,
            SelectUi,
        },

        props: ['title'],

        data: () => ({
            menuIsOpen: false,
            sidebarIsOpen: false,
        }),

        computed: {
            optionAccounts() {
                return this.$page.props.auth.user.accounts
                    .map(account => {
                        return {
                            label: account.title,
                            value: account.sid,
                        };
                    })
                    .sort((a, b) => a.label.localeCompare(b.label));
            },
        },

        methods: {
            toggleSideBar() {
                this.sidebarIsOpen = !this.sidebarIsOpen;
            },

            toggleMenu() {
                this.menuIsOpen = !this.menuIsOpen;
            },

            changeAccount(accounts) {
                if (accounts) {
                    this.$inertia.visit(this.$route(this.$routeName(), accounts[0]));
                }
            },
        },
    };
</script>
